import UI from "../../components/ExcerciseTypes/Design/UserInterface";

const json = {

  1: { // Exercise num
    unit: 'Starter',
    id: 'SB3-S-P4-E1',
    audio: 'img/FriendsPlus/Page4/Audio/audio-e1-p4.mp3',
    video: '',
    component: UI,
    recorder: true,
    isAllowSubmit: false,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page4/E1/1.jpg' },
        { url: 'img/FriendsPlus/Page4/E1/2.jpg', audioUrl: 'img/FriendsPlus/Page4/Audio/tieude-e1-p4.mp3' },
        { url: 'img/FriendsPlus/Page4/E1/3.jpg' },
      ],
      [{ url: 'img/FriendsPlus/Page4/E1/4.jpg' }],
    ],
  },
  2: { // Exercise num
    unit: 'Starter',
    id: 'SB3-S-P4-E2',
    audio: '',
    video: '',
    component: UI,
    recorder: true,
    isAllowSubmit: false,
    questionImage: [ // Row
      [{ url: 'img/FriendsPlus/Page4/E2/1.jpg' }],
      [{ url: 'img/FriendsPlus/Page4/E1/4.jpg' }],
    ],
  },
  3: { // Exercise num
    unit: 'Starter',
    id: 'SB3-S-P4-E3',
    audio: 'img/FriendsPlus/Page4/Audio/audio-e3-p4.mp3',
    video: 'Videos/E3.p4.mp4',
    component: UI,
    recorder: true,
    isAllowSubmit: false,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page4/E3/1.jpg' },
        { url: 'img/FriendsPlus/Page4/E3/2.jpg', audioUrl: 'img/FriendsPlus/Page4/Audio/tieude-e3-p4.mp3' },
        { url: 'img/FriendsPlus/Page4/E3/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page4/E3/4.jpg', audioUrl: 'img/FriendsPlus/Page4/Audio/anh1-e3-p4.mp3' },
        { url: 'img/FriendsPlus/Page4/E3/5.jpg', audioUrl: 'img/FriendsPlus/Page4/Audio/anh2-e3-p4.mp3' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page4/E3/6.jpg', audioUrl: 'img/FriendsPlus/Page4/Audio/anh3-e3-p4.mp3' },
        { url: 'img/FriendsPlus/Page4/E3/7.jpg', audioUrl: 'img/FriendsPlus/Page4/Audio/anh4-e3-p4.mp3' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page4/E3/8.jpg', audioUrl: 'img/FriendsPlus/Page4/Audio/anh5-e3-p4.mp3' },
        { url: 'img/FriendsPlus/Page4/E3/9.jpg', audioUrl: 'img/FriendsPlus/Page4/Audio/anh6-e3-p4.mp3' },
      ],
    ],
  },

}

export default json;